/**
 * Resolve Bearer token for API requests.
 * Prefer Keycloak (updated immediately on refresh); fall back to Redux jwtToken.
 * @param {Object} store
 * @return {string}
 */
export default function resolveAuthToken(store) {
  const keycloakToken = typeof window !== 'undefined'
    && window.keycloakAuth
    && window.keycloakAuth.token;
  if (keycloakToken) {
    return keycloakToken;
  }

  const userDetail = store.getState().UserDetail.get('userDetail');
  return (userDetail && userDetail.jwtToken) || '';
}
